import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  Card, CardText, TextField, RaisedButton, SelectField, MenuItem,
  RadioButton, RadioButtonGroup, DatePicker,
} from "material-ui";
import DateIcon from "material-ui/svg-icons/action/date-range";
import customDateTimeFormat from "../../../helpers/dateFormat";
import {
  OpenSolicitudEditarCreacion, CambiarMontoArancelPrestacion, CambiarTipoUnidad, CambiarCodigoPrestacionPrestador,
  CambiarPabellonPrestacion, CambiarGlosaPrestacionPrestador, CambiarCodigoFonasa, CambiarItemImed,
  CambiarTipoProfesional, CambiarInicioVigenciaArancel, CambiarTipoPrestacion,
  CambiarPertenenciaFonasa, ValidarGuarismo, LoadingValidaCodIsapreFonasa, validaCodIsapreFonasa, LimpiarCodIsapreFonasa,
} from "./actions";
import { GuardarSolicitudEditarCreacion } from "../GrillaSolicitud/actions";
import {
  ObtenerTiposUnidad, ObtenerItemImed, ObtenerTipoProfesional,
  ObtenerPertenenciaFonasa, ObtenerTiposPrestacionesIsapre,
} from "../../Global/actions";
import banmedicaTheme from "./../../../config/banmedicaTheme";
import styles from "./../../styles/styles";
import valorUnidad from "../../../helpers/valorUnidad";

class SolicitudEditarCreacion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showCodigoFonasa: true,
      itemImedNoPermitidos: [],
    };
  }

  componentWillMount() {
    this.props.dispatch(ObtenerTiposPrestacionesIsapre());
    this.props.dispatch(ObtenerTiposUnidad());
    this.props.dispatch(ObtenerItemImed());
    this.props.dispatch(ObtenerTipoProfesional());
    this.props.dispatch(ObtenerPertenenciaFonasa());

    if (this.props.ENV.GRUPOS_NO_VALIDAN_GUARISMO.includes(this.props.detallePrestacion.tipoPrestacion)) {
      this.props.dispatch(ValidarGuarismo(false));
    } else {
      this.props.dispatch(ValidarGuarismo(true));
    }
    if (this.props.ENV.GRUPOS_NO_VALIDAN_ITEMIMED.map((p) => p.IdGrupo).includes(this.props.detallePrestacion.tipoPrestacion)) {
      const itemImedNo = this.props.ENV.GRUPOS_NO_VALIDAN_ITEMIMED.filter((p) => p.IdGrupo === this.props.detallePrestacion.tipoPrestacion)[0].ItemImed;
      this.setState({ itemImedNoPermitidos: itemImedNo });
    }

    switch (this.props.detallePrestacion.pertenenciaFonasa) {
      case 1:
      case "1":
      case 2:
      case "2":
        this.setState({ showCodigoFonasa: true });
        break;
      case 3:
      case "3":
        this.setState({ showCodigoFonasa: false });
        this.props.dispatch(CambiarCodigoFonasa(null));
        this.props.dispatch(LimpiarCodIsapreFonasa(null));
        break;
      default:
        this.setState({ showCodigoFonasa: true });
    }
  }

  CloseSolicitudEditarCreacion = () => {
    this.props.dispatch(OpenSolicitudEditarCreacion(false, null));
  }

  CambiarMontoArancelPrestacion = (event) => {
    const validacion = valorUnidad.Validar(event.target.value, this.props.detallePrestacion.tipoUnidad);
    this.props.dispatch(CambiarMontoArancelPrestacion(validacion.valor, validacion.error));
  }

  CambiarTipoUnidad = (event, index, value) => {
    //console.log("UNIDAD:", value);
    //console.log("TIPO UNIDAD:", typeof value);
    const validacion = valorUnidad.Validar(this.props.detallePrestacion.montoArancelPrestacion, value);
    this.props.dispatch(CambiarTipoUnidad(value, validacion.error));
  }

  CambiarCodigoPrestacionPrestador = (event) => {
    this.props.dispatch(CambiarCodigoPrestacionPrestador(event.target.value));
  }

  CambiarPabellonPrestacion = (event) => {
    this.props.dispatch(CambiarPabellonPrestacion(event.target.value));
  }

  CambiarGlosaPrestacionPrestador = (event) => {
    this.props.dispatch(CambiarGlosaPrestacionPrestador(event.target.value));
  }

  CambiarCodigoFonasa = (event) => {
    const re = /^[0-9]+$/;
    if (event.target.value === "" || re.test(event.target.value)) {
      this.props.dispatch(LoadingValidaCodIsapreFonasa(true));
      this.props.dispatch(CambiarCodigoFonasa(event.target.value));
      this.props.dispatch(validaCodIsapreFonasa());
    }
  }

  CambiarItemImed = (event, index, value) => {
    if (this.state.itemImedNoPermitidos.includes(value)) {
      this.props.dispatch(CambiarItemImed(null, "Item IMED no permitido para el grupo"));
    } else {
      this.props.dispatch(CambiarItemImed(value));
    }
  }

  CambiarTipoProfesional = (event, index, value) => {
    this.props.dispatch(CambiarTipoProfesional(value));
  }

  CambiarInicioVigenciaArancel = (event, date) => {
    const dateMin = new Date(Date.now());
    dateMin.setDate(dateMin.getDate() + 15);
    dateMin.setHours(0, 0, 0, 0);
    let dateMod = date;
    if (dateMin > date) {
      dateMod = dateMin;
      this.props.dispatch(CambiarInicioVigenciaArancel(
        dateMod,
        `La fecha no puede ser menor a ${dateMin.toLocaleDateString()}`
      ));
    } else {
      this.props.dispatch(CambiarInicioVigenciaArancel(dateMod));
    }
  }

  CambiarTipoPrestacion = (event, index, value) => {
    this.props.dispatch(CambiarTipoPrestacion(value));
    if (this.props.ENV.GRUPOS_NO_VALIDAN_GUARISMO.includes(value)) {
      this.props.dispatch(ValidarGuarismo(false));
    } else {
      this.props.dispatch(ValidarGuarismo(true));
    }

    this.setState({ itemImedNoPermitidos: [] });
    if (this.props.ENV.GRUPOS_NO_VALIDAN_ITEMIMED.map((p) => p.IdGrupo).includes(value)) {
      const itemImedNo = this.props.ENV.GRUPOS_NO_VALIDAN_ITEMIMED.filter((p) => p.IdGrupo === value)[0].ItemImed;
      this.setState({ itemImedNoPermitidos: itemImedNo });
      if (itemImedNo.includes(this.props.detallePrestacion.itemImed)) {
        this.props.dispatch(CambiarItemImed(null, "Item IMED no permitido para el grupo"));
      }
    }
  }

  CambiarPertenenciaFonasa = (event, value) => {
    switch (value) {
      case 1:
      case "1":
      case 2:
      case "2":
        this.setState({ showCodigoFonasa: true });
        break;
      case 3:
      case "3":
        this.setState({ showCodigoFonasa: false });
        this.props.dispatch(CambiarCodigoFonasa(null));
        this.props.dispatch(LimpiarCodIsapreFonasa(null));
        break;
      default:
        this.setState({ showCodigoFonasa: true });
    }
    this.props.dispatch(CambiarPertenenciaFonasa(value));
  }

  GuardarSolicitudEditarCreacion = () => {
    let exit = false;

    if (!this.props.detallePrestacion.codigoPrestacionPrestador) {
      this.codigoPrestacionPrestador.focus();
      this.props.dispatch(CambiarCodigoPrestacionPrestador(
        this.props.detallePrestacion.codigoPrestacionPrestador,
        "Falta Código Prestación"
      ));
      exit = true;
    }
    if (!this.props.detallePrestacion.glosaPrestacionPrestador) {
      this.glosaPrestacionPrestador.focus();
      this.props.dispatch(CambiarGlosaPrestacionPrestador(
        this.props.detallePrestacion.glosaPrestacionPrestador,
        "Ingresar Glosa "
      ));
      exit = true;
    }
    if (!this.props.detallePrestacion.tipoProfesional) {
      this.props.dispatch(CambiarTipoProfesional(
        this.props.detallePrestacion.tipoProfesional,
        "Seleccionar Profesional "
      ));
      exit = true;
    }
    if (!this.props.detallePrestacion.tipoPrestacion) {
      this.props.dispatch(CambiarTipoPrestacion(
        this.props.detallePrestacion.tipoPrestacion,
        "Seleccionar Prestación"
      ));
      exit = true;
    }
    if (!this.props.detallePrestacion.pabellonPrestacion && this.props.validarGuarismo) {
      this.pabellonPrestacion.focus();
      this.props.dispatch(CambiarPabellonPrestacion(
        this.props.detallePrestacion.pabellonPrestacion,
        "Seleccionar Guarismo de DP o Sala de Procedimientos"
      ));
      exit = true;
    }
    if (!this.props.detallePrestacion.inicioVigenciaArancel) {
      this.props.dispatch(CambiarInicioVigenciaArancel(
        this.props.detallePrestacion.inicioVigenciaArancel,
        "Seleccionar Inicio de Vigencia"
      ));
      exit = true;
    }
    if (!this.props.detallePrestacion.pertenenciaFonasa) {
      this.props.dispatch(CambiarPertenenciaFonasa(
        this.props.detallePrestacion.pertenenciaFonasa,
        "Seleccionar Pertenencia a Fonasa"
      ));
      exit = true;
    }
    if ((!this.props.detallePrestacion.codigoFonasa || this.props.detallePrestacion.codigoFonasaValid === false) && this.state.showCodigoFonasa) {
      this.codigoFonasa.focus();
      this.props.dispatch(CambiarCodigoFonasa(
        this.props.detallePrestacion.codigoFonasa,
        "Debe ingresar código Fonasa válido"
      ));
      exit = true;
    }

    if (this.props.detallePrestacion.itemImed === "" || this.props.detallePrestacion.itemImed == null) {
      this.props.dispatch(CambiarItemImed(
        this.props.detallePrestacion.itemImed,
        "Debe Seleccionar Item Imed"
      ));
      exit = true;
    }

    if (!this.props.detallePrestacion.montoArancelPrestacion) {
      this.montoArancelPrestacion.focus();
      this.props.dispatch(CambiarMontoArancelPrestacion(
        this.props.detallePrestacion.montoArancelPrestacion,
        "Indicar monto del arancel"
      ));
      exit = true;
    } else {
      // const valorPrestacion = "0";
      const validacionUn = valorUnidad.Validar(this.props.detallePrestacion.montoArancelPrestacion, this.props.detallePrestacion.tipoUnidad);
      if (validacionUn.error) {
        this.props.dispatch(CambiarMontoArancelPrestacion(
          this.props.detallePrestacion.montoArancelPrestacion,
          validacionUn.error
        ));
        exit = true;
      }
    }


    if (!exit) {
      this.props.dispatch(GuardarSolicitudEditarCreacion(this.props.detallePrestacion));
      this.props.dispatch(OpenSolicitudEditarCreacion(false, null));
    }
  }


  render() {
    const { REACT_APP_REAJUSTAR_ARANCEL_FECHA_VIGENCIA_MINIMA: fechaVigenciaPrestador } = this.props.ENV;
    let today = new Date();
    today.setDate(today.getDate() + fechaVigenciaPrestador);
    const minDate = today;

    const menuListUnidad = [];
    if (this.props.tiposUnidad) {
      this.props.tiposUnidad.forEach((uni) => {
        menuListUnidad.push(<MenuItem key={uni.Unidad} value={uni.Unidad} primaryText={uni.Descripcion} />);
      });
    }

    const menuListItemImed = [];
    if (this.props.itemsImed) {
      this.props.itemsImed.forEach((element) => {
        menuListItemImed.push(<MenuItem key={element.Item} value={element.Item} primaryText={element.Descripcion} />);
      });
    }

    const menuListPermanenciaFonasa = [];
    if (this.props.pertenenciasFonasa) {
      this.props.pertenenciasFonasa.forEach((element) => {
        menuListPermanenciaFonasa.push(<RadioButton key={element.Simbolo} value={element.Simbolo} label={element.Descripcion} />);
      });
    }

    const menuListTipoPrestaciones = [];
    if (this.props.tiposPrestaciones) {
      this.props.tiposPrestaciones.forEach((element) => {
        if (element.Id.toString() !== "0") {
          menuListTipoPrestaciones.push(<MenuItem key={element.Id} value={element.Id} primaryText={`${element.TipoAtencion}: ${element.Descripcion}`} />);
        }
      });
    }

    const menuListTipoProfesional = [];
    if (this.props.tiposProfesionales) {
      this.props.tiposProfesionales.forEach((element) => {
        menuListTipoProfesional.push(<MenuItem key={element.Tipo} value={element.Tipo} primaryText={element.Descripcion} />);
      });
    }

    return (
      <div style={{ width: 990 }}>
        <div style={styles.frameContenidoGeneral}>
          <Card zDepth={0} style={{ paddingBottom: 0 }}>
            <CardText style={{ paddingBottom: 0 }}>
              <div className="row" style={{ paddingBottom: 0 }}>
                <div className="col-12" style={{ margin: 0, padding: 0 }}>
                  <div style={styles.h1}>Editar línea de detalle de solicitud
                  </div>
                  <div style={styles.h3}>Creación
                  </div>
                </div>
              </div>
              <div className="row" style={{ paddingBottom: 0, marginTop: 15 }}>
                <div className="col-1" style={styles.tituloEditarLinea}>
                  Arancel:
                </div>
                <div className="col-1" style={styles.datoEditarLinea}>
                  {this.props.detallePrestacion.glosaTipoArancel}
                </div>
                <div className="col-2" style={styles.tituloEditarLinea}>
                  Centro de Atención:
                </div>
                <div className="col-1" style={styles.datoEditarLinea}>
                  {this.props.detallePrestacion.glosaCentroAtencion}
                </div>
                <div className="col-2" style={styles.tituloEditarLinea}>
                  Tipo Atención:
                </div>
                <div className="col-1" style={styles.datoEditarLinea}>
                  {this.props.detallePrestacion.tipoAtencion == "A" ? "AMBULATORIA" : "HOSPITALARIA"}
                </div>
              </div>
              <div className="row" style={{ paddingBottom: 0, marginTop: 15 }}>
                <div className="col-2">
                  <div style={styles.floatingClaseSelect2}>Valor</div>
                  <TextField
                    name="text_sec_montoArancel"
                    id="text_sec_montoArancel"
                    ref={(c) => { this.montoArancelPrestacion = c; }}
                    value={this.props.detallePrestacion.montoArancelPrestacion}
                    onChange={this.CambiarMontoArancelPrestacion}
                    underlineStyle={styles.underlineSelectField}
                    inputStyle={styles.h4}
                    style={styles.selectFieldNuevaPrestacionTablaInferior}
                    errorText={this.props.detallePrestacion.montoArancelPrestacionErr || ""}
                    errorStyle={styles.errorStyle}
                  />
                </div>
                <div className="col-5">
                  <div style={styles.floatingClaseSelect2}>Unidad</div>
                  <SelectField
                    name="dd_sec_tipounidad"
                    id="dd_sec_tipounidad"
                    value={this.props.detallePrestacion.tipoUnidad}
                    onChange={this.CambiarTipoUnidad}
                    labelStyle={styles.h4}
                    underlineStyle={styles.underlineSelectField}
                    style={styles.selectFieldNuevaPrestacion}
                    iconStyle={styles.iconSelectField}
                    menuItemStyle={styles.menuItemStyleSelectField}
                    selectedMenuItemStyle={styles.selectedMenuItemSelectFiueld}
                    errorText={this.props.detallePrestacion.tipoUnidadErr || ""}
                    errorStyle={styles.errorStyle}
                  >{menuListUnidad}
                  </SelectField>
                </div>
              </div>
              <div className="row" style={{ paddingBottom: 0 }}>
                <div className="col-4" style={styles.colSelectFieldActualizar}>
                  <div style={styles.floatingClaseSelect}>Código Prestación Prestador</div>
                  <TextField
                    name="text_sec_codPrestacionPrestador"
                    id="text_sec_codPrestacionPrestador"
                    ref={(c) => { this.codigoPrestacionPrestador = c; }}
                    value={this.props.detallePrestacion.codigoPrestacionPrestador}
                    onChange={this.CambiarCodigoPrestacionPrestador}
                    underlineStyle={styles.underlineSelectField}
                    inputStyle={styles.h4}
                    style={styles.selectFiledStyle}
                    errorText={this.props.detallePrestacion.codigoPrestacionPrestadorErr || ""}
                    errorStyle={styles.errorStyle}
                  />
                </div>
                <div className="col-4" style={styles.colSelectFieldActualizar}>
                  <div style={styles.floatingClaseSelect}>Tipo de Prestación</div>
                  <SelectField
                    name="dd_sec_tipoPrestacion"
                    id="dd_sec_tipoPrestacion"
                    value={this.props.detallePrestacion.tipoPrestacion}
                    onChange={this.CambiarTipoPrestacion}
                    labelStyle={styles.h4}
                    underlineStyle={styles.underlineSelectField}
                    style={styles.selectFiledStyle}
                    iconStyle={styles.iconSelectField}
                    menuItemStyle={styles.menuItemStyleSelectField}
                    selectedMenuItemStyle={styles.selectedMenuItemSelectFiueld}
                    errorText={this.props.detallePrestacion.tipoPrestacionErr || ""}
                    errorStyle={styles.errorStyle}
                  >
                    {menuListTipoPrestaciones}
                  </SelectField>
                </div>
                {this.props.validarGuarismo ?
                  <div className="col-4" style={styles.colSelectFieldActualizar}>
                    <div style={styles.floatingClaseSelect}>Guarismo de DP o Sala de Procedimiento</div>
                    <TextField
                      name="text_sec_guarismo"
                      id="text_sec_guarismo"
                      ref={(c) => { this.pabellonPrestacion = c; }}
                      value={this.props.detallePrestacion.pabellonPrestacion}
                      onChange={this.CambiarPabellonPrestacion}
                      underlineStyle={styles.underlineSelectField}
                      inputStyle={styles.h4}
                      style={styles.selectFiledStyle}
                      errorText={this.props.detallePrestacion.pabellonPrestacionErr || ""}
                      errorStyle={styles.errorStyle}
                    />
                  </div>
                  : null}
              </div>
              <div className="row" style={{ paddingBottom: 0 }}>
                <div className="col-4" style={styles.colSelectFieldActualizar}>
                  <div style={styles.floatingClaseSelect2}>Glosa Prestación Prestador</div>
                  <TextField
                    name="txt_sec_glosaprestacionPrestador"
                    id="txt_sec_glosaprestacionPrestador"
                    ref={(c) => { this.glosaPrestacionPrestador = c; }}
                    value={this.props.detallePrestacion.glosaPrestacionPrestador}
                    onChange={this.CambiarGlosaPrestacionPrestador}
                    underlineStyle={styles.underlineSelectField}
                    inputStyle={styles.h4}
                    style={styles.selectFiledStyle}
                    errorText={this.props.detallePrestacion.glosaPrestacionPrestadorErr || ""}
                    errorStyle={styles.errorStyle}
                  />
                </div>
                <div className="col-4" style={styles.colSelectFieldActualizar}>
                  <div style={styles.floatingClaseSelect2}>Inicio Vigencia</div>
                  <div className="container">
                    <div className="row" >
                      <DatePicker
                        name="dp_sec_inicioVigencia"
                        id="dp_sec_inicioVigencia"
                        mode="landscape"
                        minDate={minDate}
                        DateTimeFormat={customDateTimeFormat.cl()}
                        locale="es-CL"
                        firstDayOfWeek={1}
                        value={this.props.detallePrestacion.inicioVigenciaArancel}
                        onChange={this.CambiarInicioVigenciaArancel}
                        underlineStyle={styles.underlineSelectField}
                        style={styles.datepickerStyle}
                        inputStyle={styles.h4}
                        errorText={this.props.detallePrestacion.inicioVigenciaArancelErr || ""}
                      />
                      <DateIcon
                        // iconStyle={{ height: 20, width: 20 }}
                        style={{ marginTop: 3, marginLeft: 5 }}
                        color={banmedicaTheme.palette.accent1Color}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-4" style={styles.colSelectFieldActualizar}>
                  <div style={styles.floatingClaseSelect2}>Tipo de Profesional</div>
                  <SelectField
                    name="dd_sec_tipoProfesional"
                    id="dd_sec_tipoProfesional"
                    value={this.props.detallePrestacion.tipoProfesional}
                    onChange={this.CambiarTipoProfesional}
                    labelStyle={styles.h4}
                    underlineStyle={styles.underlineSelectField}
                    style={styles.selectFiledStyle}
                    iconStyle={styles.iconSelectField}
                    menuItemStyle={styles.menuItemStyleSelectField}
                    selectedMenuItemStyle={styles.selectedMenuItemSelectFiueld}
                    errorText={this.props.detallePrestacion.tipoProfesionalErr || ""}
                    errorStyle={styles.errorStyle}
                  >
                    {menuListTipoProfesional}
                  </SelectField>
                </div>
              </div>
              <div className="row" style={{ paddingBottom: 0 }}>
                <div className="col-4">
                  <div style={styles.floatingClaseSelect2}>Pertenencia Fonasa</div>
                  <RadioButtonGroup
                    name="rd_sec_pertenenciaFonasa"
                    id="rd_sec_pertenenciaFonasa"
                    defaultSelected={this.props.detallePrestacion.pertenenciaFonasa}
                    onChange={this.CambiarPertenenciaFonasa}
                    style={styles.customWidth}
                  >
                    {menuListPermanenciaFonasa}
                  </RadioButtonGroup>
                  {this.props.detallePrestacion.pertenenciaFonasaErr ?
                    <div style={{ color: "#f44336" }}>{this.props.detallePrestacion.pertenenciaFonasaErr}</div>
                    : null}
                </div>
                <div className="col-4" style={styles.colSelectFieldActualizar}>
                  {this.state.showCodigoFonasa ?
                    <div>
                      <div style={styles.floatingClaseSelect2}>Código Fonasa Informado por Prestador</div>
                      <TextField
                        name="txt_sec_codigoFonasa"
                        id="txt_sec_codigoFonasa"
                        ref={(c) => { this.codigoFonasa = c; }}
                        value={this.props.detallePrestacion.codigoFonasa || ""}
                        onChange={this.CambiarCodigoFonasa}
                        underlineStyle={styles.underlineSelectField}
                        inputStyle={styles.h4}
                        style={styles.selectFiledStyle}
                        errorText={this.props.detallePrestacion.codigoFonasaErr || ""}
                        errorStyle={styles.errorStyle}
                        maxLength={10}
                      />
                      {this.props.codigoFonasaLoading && !this.props.detallePrestacion.codigoFonasaErr ?
                        <span>
                          <div style={styles.codFonasaLoading}>
                            validando ...
                          </div>
                        </span>
                        :
                        <span>
                          {this.props.detallePrestacion.codigoFonasaValid === true ?
                            <div style={styles.codFonasaValido}>
                              Código válido
                            </div>
                            :
                            null}
                        </span>
                      }
                    </div>
                    : null}
                </div>
                <div className="col-4" style={styles.colSelectFieldActualizar}>
                  <div style={styles.floatingClaseSelect2}>Item IMED</div>
                  <SelectField
                    name="dd_sec_itemImed"
                    id="dd_sec_itemImed"
                    value={this.props.detallePrestacion.itemImed}
                    onChange={this.CambiarItemImed}
                    labelStyle={styles.h4}
                    underlineStyle={styles.underlineSelectField}
                    style={styles.selectFiledStyle}
                    iconStyle={styles.iconSelectField}
                    menuItemStyle={styles.menuItemStyleSelectField}
                    selectedMenuItemStyle={styles.selectedMenuItemSelectField}
                    errorText={this.props.detallePrestacion.itemImedErr || ""}
                    errorStyle={styles.errorStyle}
                  >
                    {menuListItemImed}
                  </SelectField>
                </div>
              </div>
              <div className="row">
                <div className="col-12" style={{ textAlign: "right", marginTop: 10, marginBottom: 10 }}>
                  <RaisedButton
                    label="Cancelar"
                    onClick={this.CloseSolicitudEditarCreacion}
                    backgroundColor="#fff"
                    overlayStyle={{ borderRadius: 5 }}
                    labelStyle={{
                      fontSize: "11px", color: "#757575", paddingLeft: 10, paddingRight: 5,
                    }}
                    style={{ width: "145px", borderRadius: 5 }}
                    buttonStyle={{ border: "2px solid #C3C3C3", borderRadius: 5 }}
                  />
                  <RaisedButton
                    label="Guardar"
                    onClick={this.GuardarSolicitudEditarCreacion}
                    secondary
                    labelStyle={{ fontSize: "11px" }}
                    overlayStyle={{ borderRadius: 5 }}
                    rippleStyle={{ borderRadius: 5 }}
                    style={{ width: "130px", borderRadius: 5, marginLeft: 20 }}
                    buttonStyle={{ borderRadius: 5 }}
                  />
                </div>
              </div>
            </CardText>
          </Card>
        </div>
      </div>
    );
  }
}


SolicitudEditarCreacion.propTypes = {
  tiposPrestaciones: PropTypes.array.isRequired,
  tiposUnidad: PropTypes.array.isRequired,
  itemsImed: PropTypes.array.isRequired,
  tiposProfesionales: PropTypes.array.isRequired,
  pertenenciasFonasa: PropTypes.array.isRequired,
  detallePrestacion: PropTypes.any.isRequired,
  dispatch: PropTypes.func.isRequired,
  validarGuarismo: PropTypes.bool.isRequired,
  codigoFonasaLoading: PropTypes.bool.isRequired,
  ENV: PropTypes.any.isRequired,
};

const mapStateToProps = (state) => ({
  tiposPrestaciones: state.global.tiposPrestacionesIsapre,
  tiposUnidad: state.global.tiposUnidad,
  itemsImed: state.global.itemsImed,
  tiposProfesionales: state.global.tiposProfesionales,
  pertenenciasFonasa: state.global.pertenenciasFonasa,

  detallePrestacion: {
    glosaTipoArancel: state.solicitudEditarCreacion.detallePrestacion.glosaTipoArancel,
    tipoAtencion: state.solicitudEditarCreacion.detallePrestacion.tipoAtencion,
    glosaCentroAtencion: state.solicitudEditarCreacion.detallePrestacion.glosaCentroAtencion,
    rowGuid: state.solicitudEditarCreacion.detallePrestacion.rowGuid,

    montoArancelPrestacion: state.solicitudEditarCreacion.detallePrestacion.montoArancelPrestacion,
    tipoUnidad: state.solicitudEditarCreacion.detallePrestacion.tipoUnidad,
    codigoPrestacionPrestador: state.solicitudEditarCreacion.detallePrestacion.codigoPrestacionPrestador,
    pabellonPrestacion: state.solicitudEditarCreacion.detallePrestacion.pabellonPrestacion,
    glosaPrestacionPrestador: state.solicitudEditarCreacion.detallePrestacion.glosaPrestacionPrestador,
    codigoFonasa: state.solicitudEditarCreacion.detallePrestacion.codigoFonasa,
    itemImed: state.solicitudEditarCreacion.detallePrestacion.itemImed,
    tipoProfesional: state.solicitudEditarCreacion.detallePrestacion.tipoProfesional,
    inicioVigenciaArancel: state.solicitudEditarCreacion.detallePrestacion.inicioVigenciaArancel,
    tipoPrestacion: state.solicitudEditarCreacion.detallePrestacion.tipoPrestacion,
    pertenenciaFonasa: state.solicitudEditarCreacion.detallePrestacion.pertenenciaFonasa,

    codigoPrestacionPrestadorErr: state.solicitudEditarCreacion.detallePrestacion.codigoPrestacionPrestadorErr,
    tipoPrestacionErr: state.solicitudEditarCreacion.detallePrestacion.tipoPrestacionErr,
    pabellonPrestacionErr: state.solicitudEditarCreacion.detallePrestacion.pabellonPrestacionErr,
    tipoUnidadErr: state.solicitudEditarCreacion.detallePrestacion.tipoUnidadErr,
    glosaPrestacionPrestadorErr: state.solicitudEditarCreacion.detallePrestacion.glosaPrestacionPrestadorErr,
    codigoFonasaErr: state.solicitudEditarCreacion.detallePrestacion.codigoFonasaErr,
    itemImedErr: state.solicitudEditarCreacion.detallePrestacion.itemImedErr,
    tipoProfesionalErr: state.solicitudEditarCreacion.detallePrestacion.tipoProfesionalErr,
    grupoPrestacionIsapreErr: state.solicitudEditarCreacion.detallePrestacion.grupoPrestacionIsapreErr,
    codigoPrestacionIsapreErr: state.solicitudEditarCreacion.detallePrestacion.codigoPrestacionIsapreErr,
    glosaPrestacionIsapreErr: state.solicitudEditarCreacion.detallePrestacion.glosaPrestacionIsapreErr,
    montoArancelPrestacionErr: state.solicitudEditarCreacion.detallePrestacion.montoArancelPrestacionErr,
    inicioVigenciaArancelErr: state.solicitudEditarCreacion.detallePrestacion.inicioVigenciaArancelErr,
    tipoAtencionErr: state.solicitudEditarCreacion.detallePrestacion.tipoAtencionErr,
    pertenenciaFonasaErr: state.solicitudEditarCreacion.detallePrestacion.pertenenciaFonasaErr,

    codigoFonasaValid: state.solicitudEditarCreacion.detallePrestacion.codigoFonasaValid,
  },
  validarGuarismo: state.solicitudEditarCreacion.validarGuarismo,
  codigoFonasaLoading: state.solicitudEditarCreacion.codigoFonasaLoading,
  ENV: state.global.ENV,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(SolicitudEditarCreacion);
